import { createSlice } from "@reduxjs/toolkit";

const defaultNav = [
    { name: "Home", url:"/enrica" },
    { name: "Consumi", url:"/enrica/consumi" },
    { name: "Movimenti", url:"/enrica/movimenti" },
    { name: "Documenti", url:"/enrica/documenti" },
    { name: "Altri oneri", url: "/enrica/altri-oneri"},
    { name: "Fai da te", url: "/enrica/fai-da-te"},
]

export const navSlice = createSlice({
    name: 'navigator',
    initialState: {
        order: [
            { name: "Home", url:"/enrica" },
            { name: "Consumi", url:"/enrica/consumi" },
            { name: "Movimenti", url:"/enrica/movimenti" },
            { name: "Documenti", url:"/enrica/documenti" },
            { name: "Altri oneri", url: "/enrica/altri-oneri"},
            { name: "Fai da te", url: "/enrica/fai-da-te"},
        ]
    },
    reducers: {
        setOrder: (state, action) => {
            const index = defaultNav.findIndex((nav) => nav.name === action.payload);
            let currPages = defaultNav[index]
            state.order = [currPages, ...defaultNav.slice(0, index), ...defaultNav.slice(index + 1)]
        },
    }
});

export const { setOrder } = navSlice.actions;
export default navSlice.reducer;